export const getPublicFormInputClass = (
  errors: Record<string, boolean>,
  fieldName: string,
) => {
  const baseClass =
    "w-full border p-2.5 text-sm rounded-lg shadow-sm focus:border-indigo-500 focus:ring-indigo-500 bg-gray-50";
  const errorClass = "border-red-500 focus:border-red-500 focus:ring-red-500";
  const normalClass = "border-gray-300";

  return `${baseClass} ${errors[fieldName] ? errorClass : normalClass}`;
};

export const getPublicFormLabelClass = (
  errors: Record<string, boolean>,
  fieldName: string,
) => {
  const baseClass = "block text-sm font-medium";
  const errorClass = "text-red-600";
  const normalClass = "text-gray-700";

  return `${baseClass} ${errors[fieldName] ? errorClass : normalClass}`;
};
